module.exports = __webpack_public_path__ + "img/mark-icon.2c58a05f.png";